import { render } from "./MedicalPlatform.vue?vue&type=template&id=34f9427e&scoped=true"
import script from "./MedicalPlatform.vue?vue&type=script&lang=js"
export * from "./MedicalPlatform.vue?vue&type=script&lang=js"

import "./MedicalPlatform.vue?vue&type=style&index=0&id=34f9427e&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f9427e"]])

export default __exports__